
let getPickers = () => {
	return import(/* webpackChunkName: "dataPickers" */ './../../../common/controls/Datetime/QdDatePickers').then((module) => {
		return module;
	});
}

export default {
	reload: (rootElement?: HTMLElement) => {
		var nodes = (rootElement || document).querySelectorAll(".qd-inline-datetime-picker, .qd-data-pair-picker, .qd-date-picker");
		if (nodes.length != 0) {
			getPickers().then(module => {
				for (let i = 0; i < nodes.length; i++) {
					let node = nodes[i] as HTMLElement;
					if (node.classList.contains("qd-inline-datetime-picker")) {
						module.renderDatetime(node);
					}
					if (node.classList.contains("qd-data-pair-picker")) {
						module.renderDatetimePair(node);
					}
					if (node.classList.contains("qd-date-picker")) {
						module.renderDate(node);
					}
				}
			})
			.catch(error => console.error(error));
		}
	}
} 